import React, { FC, useCallback, useState } from 'react';
import gksLogo from 'assets/img/gksLogo.png';

import BuiltOnEnkrateia from 'components/BuiltOnEnkrateia/BuiltOnEnkrateia';
import PoweredBy from 'components/PoweredBy/PoweredBy';
import Footer from 'components/Footer/Footer';

import { DoubleChevronRight } from '../SvgIcons';

import './SideBar.scss';

export interface SideBarProps {
  children: React.ReactNode;
  variant?: 'traro' | 'kliparo';
  collapsible?: boolean;
  initiallyCollapsed?: boolean;
  className?: string;
}

const SideBar: FC<SideBarProps> = ({
  children,
  variant = 'traro',
  collapsible = false,
  initiallyCollapsed = false,
  className = '',
}) => {
  const [open, setOpen] = useState(!initiallyCollapsed);
  const toggleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return (
    <aside className={`enkrateia-sidebar variant-${variant} ${className} ${open ? 'open' : 'closed'}`}>
      {open && (
        <>
          {children}
          <div className="flex-grower" />
          <div className="footnote">
            <img src={gksLogo} alt="GKS" />
            <BuiltOnEnkrateia />
            <PoweredBy />
            <Footer />
          </div>
        </>
      )}
      {collapsible && (
        <button onClick={toggleOpen} type="button" className="enkrateia-sidebar-collapse-button">
          <DoubleChevronRight color="white" />
        </button>
      )}
    </aside>
  );
};

export default SideBar;
